import { useId } from "react";
import { Form } from "react-bootstrap";
import { TooltipIconComponent } from "../Icon";
export const ChoiceListComponent = (props: any) => {
  const { choicelistdata } = props;
  const { type, tooltip, legendtext, fgclass, className, name, disabled, isInvalid, selected, width, ischecked, isCallbackParam, dependentID, handlechange, component, wrapperclass, enableRadioGroupRole = false, useClickSelection = false, enableAllRadiosTabAccessible = false } = choicelistdata;
  const rejectItemList: any = [undefined, "undefined", "Undefined", "indéfinie", "Indéfinie", "Non défini"];

  const generatedId = useId();

  const legendId = enableRadioGroupRole && legendtext ? `legend-${generatedId}` : undefined;

  const onHandleChange = (event: any) => {
    // Prevent selection if disabled
    const isDisabled = event.target.getAttribute('aria-disabled') === 'true';
    if (isDisabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    
    if (handlechange && !isCallbackParam) {
      event.persist();
      const dataName = event.target.getAttribute("data-name"); 
      const name = event.target.getAttribute("data-real-name"); 
      const { value, checked }: any = event.target;
      const val = ischecked ? checked : value;
      const changedValues: any = { [ischecked ? dataName : name]: val };
      dependentID ? (changedValues.dependentID = dependentID) : null;
      return handlechange(changedValues);
    } else {
      event.persist();
      return handlechange({...event,target :{...event.target,name}});
    }
  };


  const handleClick = (event: any) => {
    // Prevent selection if disabled
    const isDisabled = event.target.getAttribute('aria-disabled') === 'true';
    if (isDisabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    
    if (useClickSelection) {
      onHandleChange(event);
    }
  };

  const handleKeyDown = (event: any) => {
    // Prevent selection if disabled
    const isDisabled = event.target.getAttribute('aria-disabled') === 'true';    
    if (useClickSelection) {
      const currentElement = event.target;
      const radioGroup = currentElement.closest('[role="radiogroup"]') || currentElement.form;
      const allRadios = Array.from(
        radioGroup?.querySelectorAll(`input[name="${name}"]`) || []
      ) as HTMLElement[];
      const currentIndex = allRadios.indexOf(currentElement);
      
      // Arrow Down/Right: Move to next radio
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % allRadios.length;
        allRadios[nextIndex]?.focus();
        return;
      }
      
      // Arrow Up/Left: Move to previous radio
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? allRadios.length - 1 : currentIndex - 1;
        allRadios[prevIndex]?.focus();
        return;
      }
      
      // Space/Enter: Select the focused radio (only if not disabled)
      if (event.key === ' ' || event.key === 'Enter') {
        if (isDisabled) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        onHandleChange(event);
      }
    }
  };
  const arroptions: any = [];
  choicelistdata?.optionsinput?.map((opt: any, i: number) => {
    if (!rejectItemList.includes(opt?.text)) {
      const newName = opt?.name ? opt?.name : name;
      const uniqID = opt?.id ? opt?.id : `${newName}-${i}`;
      const isChecked: boolean = !ischecked
      ? selected === opt?.value || parseInt(selected) === parseInt(opt?.value) || (typeof selected === "boolean" && typeof opt?.value !== "boolean" && selected)
      : selected;

      const isRadioType = type === "radio" || type === undefined;
      
      // For radio buttons with enableAllRadiosTabAccessible: use unique name per radio
      // to make all radios TAB-accessible while maintaining ARIA radiogroup semantics
      const radioName = (isRadioType && enableAllRadiosTabAccessible) ? `${name}-${uniqID}` : name;
      
      arroptions.push(
        <div key={uniqID} className={`${width ? "w-" + width : ""} ${fgclass || ""}`}>
          <Form.Check inline type={type} id={uniqID} className={className}>
            <Form.Check.Input
              type={type === "switch" || type === "checkbox" ? "checkbox" : "radio"}
              aria-disabled={disabled}
              isInvalid={isInvalid}
              value={opt?.value}
              aria-checked={isChecked}
              checked={isChecked}
              className={className}
              data-name={newName}
              data-real-name={name}
              name={radioName}
              {...(isRadioType && enableAllRadiosTabAccessible && { role: "radio" })}
              {...(!useClickSelection && {
                onChange: onHandleChange,
                onSelect: onHandleChange
              })}
              {...(useClickSelection && {
                onClick: handleClick,
                onKeyDown: handleKeyDown,
              
              })}
            />
            {type !== "switch" ? (
              <Form.Check.Label
                dangerouslySetInnerHTML={{
                  __html: opt?.text
                }}
              />
            ) : (
              ""
            )}
          </Form.Check>

          {choicelistdata?.tooltipicon && <TooltipIconComponent inputData={choicelistdata?.tooltipicon} />}
        </div>
      );
    }
  });

  return (
    <>
      {/* {choicelistdata?.optionsinput?.length > 1 ? ( */}
      <div className="form-holder clearfix">
        <Form.Group 
          controlId={`${component}-${name}`} 
          className={`clearfix mb-0 ${wrapperclass ? wrapperclass : ""}`}
          {...(enableRadioGroupRole && { role: "radiogroup" })}
          {...(enableRadioGroupRole && legendId && { "aria-labelledby": legendId })}
        >
          {tooltip ? (
            <legend className="mb-3" {...(legendId && { id: legendId })}>
              {legendtext}
              <TooltipIconComponent inputData={tooltip} />
            </legend>
          ) : (
            legendtext && <legend {...(legendId && { id: legendId })} dangerouslySetInnerHTML={{ __html: legendtext }}></legend>
          )}
          {arroptions}
        </Form.Group>
        {choicelistdata?.error && <div className={choicelistdata?.errorclass}>{choicelistdata?.error}</div>}
      </div>
      {/* ) : (
        arroptions
      )} */}
      {/* {choicelistdata?.error && choicelistdata?.optionsinput?.length === 1 && <div className={choicelistdata?.errorclass}>{choicelistdata?.error}</div>} */}
    </>
  );
};

export default ChoiceListComponent;
